export const annaLobocka = {
    'mydrId': 'annałobocka',
    'firstName': 'Anna',
    'lastName': 'Łobocka',
    'profession': 'Psychoterapeuta dzieci i młodzieży w trakcie szkolenia, psycholog',
    'avatar': 'anna-lobocka.webp',
    'slug': 'psycholog-psychoterapeuta-anna-lobocka',
    'locations': ['bydgoszcz'],
    'services': [
        ['psychoterapy', 'children'],
        ['psychoterapy', 'parents'],
    ]
}